<template>
    <div class="body">
        <div class="header">
            <p class="text-left">Use the <strong>Lengthen</strong> and <strong>Shorten</strong> buttons to change the length of the line on the right so that the centre vertical line is the same length for both.</p>
        </div>
        <div class="target" style="height: 680px;">
            <div class="row">
                <div class="col-9" v-if="line != undefined">
                    <div class="lines">
                        <line-shape  :pos="line.left.shape.upper" :line="line.left"></line-shape>
                        <div class="left-line"
                        :style="{
                            top: line.left.top + 'px',
                            left: line.left.left + 'px',
                            height: line.left.height + 'px'
                        }"></div>
                        <line-shape :pos="line.left.shape.lower" :line="line.left"></line-shape>

                        <line-shape :pos="line.right.shape.upper" :line="line.right"></line-shape>
                        <div class="right-line"
                        :style="{
                            top: line.right.top + 'px',
                            left: line.right.left + 'px',
                            height: line.right.height + 'px'
                        }"></div>
                        <line-shape :pos="line.right.shape.lower" :line="line.right"></line-shape>
                    </div>
                </div>
                <div class="col-3">
                    <div class="controlls">
                        <button class="btn rounded-pill control shorten" @click="lineLength('shorten')" 
                          @mousedown="start('shorten')" 
                          @mouseleave="stop('shorten')" 
                          @mouseup="stop('shorten')"
                          @touchstart="start('shorten')" 
                          @touchend="stop('shorten')" 
                          @touchcancel="stop('shorten')">Shorten</button>
                        <button class="btn rounded-pill control lengthen" @click="lineLength('lengthen')" 
                          @mousedown="start('lengthen')" 
                          @mouseleave="stop('lengthen')" 
                          @mouseup="stop('lengthen')" 
                          @touchstart="start('lengthen')" 
                          @touchend="stop('lengthen')" 
                          @touchcancel="stop('lengthen')">Lengthen</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import LineShape from './LineShape'
export default {
  props: ['ends', 'angle'],
  data () {
    return {
      pressTimes: null,
      interval:false,
      line: undefined,
      angles: undefined,
      point : 1
    }
  },
  components: {
    LineShape
  },
  created () {
    this.asignLine()
  },
  methods: {
    ...mapActions([
      'asyncScore'
    ]),
    asignLine () {
      /* this.line = JSON.parse(JSON.stringify(this.getByEnds({
        ends: this.ends,
        angle: this.angle
      }))) */
      this.line = this.getByEnds({
        ends: this.ends,
        angle: this.angle
      })
      this.asyncScore({
        ends: this.ends,
        angle: this.angle,
        score: Math.abs(this.line.left.height - this.line.right.height)
      })
      // this.line.score = Math.abs(this.line.left.height - this.line.right.height)
    },
    lineLength (todo) {
      switch (todo) {
        case 'shorten':
          if (this.line.right.height > 0) {
            var new_height = this.line.right.height - this.point
            var new_score = Math.abs(this.line.left.height - new_height)
            this.asyncScore({
              ends: this.ends,
              angle: this.angle,
              score: new_score,
              height: new_height
            })
          }
          break
        case 'lengthen':
          var max_height = 400 - this.line.right.top
          if (this.line.right.height < max_height) { // 260
            var new_height = this.line.right.height + this.point
            var new_score = Math.abs(this.line.left.height - new_height)
            this.asyncScore({
              ends: this.ends,
              angle: this.angle,
              score: new_score,
              height: new_height
            })
          }
          break
        default:
          break
      }
    },
    start(todo) {      
      if (this.pressTimer === null) {
          this.pressTimer = setTimeout(() => {
              // Execute function
              if(!this.interval){
                this.point = 5
                this.interval = setInterval(() => this.lineLength(todo), 30)	
              }
          }, 1000)
      }
    },
    stop(todo) {
      if (this.pressTimer !== null) {
          clearTimeout(this.pressTimer)
          clearInterval(this.interval)
          this.interval = false
          this.pressTimer = null
          this.point = 1
      }
    }
  },
  computed: {
    ...mapGetters([
      'getData', 'getByEnds'
    ]),
    angles_origin () {
      return this.getData('angles')
    }
    /* angle_line () {
      return this.getByEnds({
        ends: this.ends,
        angle: this.angle
      })
    } */
  },
  watch: {
    angle () {
      this.asignLine()
    }
  }
}
</script>
